<template>
  <div class="container-fluid">
    <location />
    <tab />
    <div class="page stats">
      <div class="tab-content" id="pills-tabContent">
        <div
          class="tab-pane fade show active"
          id="pills-1"
          role="tabpanel"
          aria-labelledby="pills-1-tab"
        >
          <div class="filter-group row">
            <div class="col-6 col-sm-4">
              <select :aria-label="$t('title.common.choose')" v-model="searchData.datetype">
                <option value="year">{{ $t("filter.common.yearly") }}</option>
                <option value="month">{{ $t("filter.common.monthly") }}</option>
                <option value="day">{{ $t("filter.common.daily") }}</option>
              </select>
            </div>
            <div class="col-6 col-sm-4">
              <date-picker
                v-model="searchData.searchdate"
                valueType="format"
                :disabled="searchData.datetype == 'year'"
                :type="searchData.datetype == 'month' ? 'year' : searchData.datetype == 'year' ? '' : 'month'"
                :placeholder="$t('title.common.choose')"
                :aria-label="$t('title.common.choose')"
                class="w-100"
              ></date-picker>
            </div>
          </div>

          <div class="card rounded-0 mb-4">
            <div
              class="card-header d-flex rounded-0 lh-base fw-semibold text-black"
            >
              {{ $t("button.stats.total_sales_sum") }}
              <span class="align-self-center ms-auto price-unit"
                >({{ $t("text.common.unit") }} : {{ $t("text.common.unit_1000") }})</span
              >
            </div>
            <div class="card-body">
              <GChart
                type="ColumnChart"
                :data="chartsData.salesumData"
                :options="chartsData.salesumtotalOptions"
              />
            </div>
          </div>

          <b-table-simple responsive>
            <b-thead>
              <b-tr>
                <b-th sticky-column>{{ $t("title.common.date") }}</b-th>
                <b-th
                  v-for="(val, key) in saleData.salesuminfo"
                  :key="'a' + key"
                >
                  {{ val[0] }}
                </b-th>
                <b-th>{{ $t("title.common.sum") }}</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr>
                <b-td sticky-column>{{ $t("title.common.sales_sum") }}</b-td>
                <b-td
                  v-for="(val, key) in saleData.salesuminfo"
                  :key="'b' + key"
                  class="text-price"
                >
                  {{ val[1] | comma("-") }}
                  <!-- <span
                    v-if="val[1]"
                    class="price-unit"
                    >천원
                  </span> -->
                </b-td>
                <b-td class="text-price">
                  {{ saleData.total_salesum | comma("-") }}
                  <!-- <span
                    v-if="saleData.total_salesum"
                    class="price-unit"
                    >천원
                  </span> -->
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import location from "@/components/Location";
import tab from "@/components/stats/statsmainTab";
import ax from "@/api/stats";
import "@/filter/common";
import { GChart } from "vue-google-charts/legacy";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/ko";

export default {
  name: "StatsMain",
  components: {
    location,
    tab,
    GChart,
    DatePicker,
  },
  data() {
    return {
      searchData: {
        datetype:
          this.$route.query.datetype ||
          (this.$store.state.searchData[this.$route.matched[0].name] &&
            this.$store.state.searchData[this.$route.matched[0].name]
              .datetype) ||
          "month",

        searchdate:
          this.$route.query.searchdate ||
          (this.$store.state.searchData[this.$route.matched[0].name] &&
            this.$store.state.searchData[this.$route.matched[0].name]
              .searchdate) ||
          this.$dayjs(new Date().setMonth(new Date().getMonth() - 1)).format(
            "YYYY-MM"
          ),
        brandno:
          (this.$store.state.admin && this.$store.state.admin.brandno) || 0,
      },
      chartsData: {
        salesumData: [],
        salesumtotalOptions: {
          chart: {
            title: this.$i18n.t("button.stats.total_sales_sum"),
          },

          legend: { position: "bottom" },
        },
      },
      saleData: { salesuminfo: [], total_salesum: 0 },
      view_hide: null,
    };
  },
  methods: {
    get_salesumlist() {
      this.$store.commit("setSearchData", {
        [this.$route.matched[0].name]: this.searchData,
      });

      ax.get_salesumlist(this.searchData, (flag, data = "") => {
        console.log(flag, data);
        this.saleData.total_salesum = data.total_salesum;
        this.saleData.salesuminfo = [];
        this.chartsData.salesumData = [[this.$i18n.t("title.common.period"), this.$i18n.t("title.common.sales_sum")]];
        Object.keys(data.salesuminfo)
          .sort((a, b) => {
            return new Date(a) - new Date(b);
          })
          .forEach((k) => {
            let datekey = k;
            if (this.searchData.datetype === "year")
              datekey = parseInt(k.substring(k.length - 4, k.length)) + this.$i18n.t("text.common.year");
            if (this.searchData.datetype === "month")
              datekey = parseInt(k.substring(k.length - 2, k.length)) + this.$i18n.t("text.common.month");
            if (this.searchData.datetype === "day")
              datekey = parseInt(k.substring(k.length - 2, k.length)) + this.$i18n.t("text.common.day");

            this.chartsData.salesumData.push([
              datekey,
              parseInt(data.salesuminfo[k].salesum) || 0,
            ]);
            this.saleData.salesuminfo.push([
              datekey,
              parseInt(data.salesuminfo[k].salesum) || 0,
            ]);
          });
        console.log("saleshopData", this.chartsData.salesumData);
      });
    },
    onSubmit(event) {
      event.preventDefault();
      this.$store.commit("setSearchData", {
        [this.$route.matched[0].name]: this.searchData,
      });
      this.get_salesumlist();
    },
  },
  created() {
    this.get_salesumlist();
  },
  watch: {
    searchData: {
      handler() {
        this.get_salesumlist();
      },
      deep: true,
    },
  },
};
</script>
